import {
    MAXIMAL_YEAR,
    MINIMAL_YEAR,
} from '@/components/TimelineIntervalChanger/composables/useTimelineIntervalChanger';
import { DateTime } from 'luxon';
import { computed, Ref, ref } from 'vue';

export function useDesignerTimelineState(
    start: Ref<DateTime>,
    monthsBefore: Ref<number>,
    monthsAfter: Ref<number>,
    timelineDisplay: Ref<string>,
) {
    const defaultTimelineDisplay = ref('sections');

    const scenarioSaved = ref(false);

    const defaultStartDateTime: Ref<DateTime> = ref(start.value);
    const defaultEndDateTime: Ref<DateTime> = ref(start.value.startOf('quarter').plus({ months: 3 }));

    const isTimelineDisplayModified = computed(() => defaultTimelineDisplay.value !== timelineDisplay.value);

    const isDisplayedTimeSpanModified = computed(() => {
        return monthsBefore.value !== 0 || monthsAfter.value !== 0;
    });

    const previousMonthButtonStatus = computed(() => {
        if (!start.value) return 'Disabled';
        const isDisabled = start.value.year === MINIMAL_YEAR && start.value.month === 1;

        return isDisabled ? 'Disabled' : 'Visible';
    });
    const nextMonthButtonStatus = computed(() => {
        if (!start.value) return 'Disabled';
        const isDisabled = start.value.year === MAXIMAL_YEAR && start.value.month === 12;

        return isDisabled ? 'Disabled' : 'Visible';
    });

    function setTimelineDisplay(value: string) {
        timelineDisplay.value = value;
    }

    function setDefaultTimelineDisplay(value: string) {
        defaultTimelineDisplay.value = value;
    }

    function setScenarioSaved(value: boolean) {
        scenarioSaved.value = value;
    }

    function setDefaultStartDateTime(value: DateTime) {
        defaultStartDateTime.value = value;
    }

    function setDefaultEndDateTime(value: DateTime) {
        defaultEndDateTime.value = value;
    }

    return {
        scenarioSaved,
        defaultStartDateTime,
        defaultEndDateTime,
        isDisplayedTimeSpanModified,
        previousMonthButtonStatus,
        nextMonthButtonStatus,
        isTimelineDisplayModified,
        setTimelineDisplay,
        setDefaultTimelineDisplay,
        setScenarioSaved,
        setDefaultStartDateTime,
        setDefaultEndDateTime,
    };
}
